import React from "react";
import Navbar from "../Component/Navbar";
import Footer from "../Component/Footer";
import AboutHero from "../Component/Miniherosection";

const AboutUs = () => {
  return (
    <>
      <Navbar />
      <AboutHero />

      {/* Mission Section */}
      <section className="py-20 bg-gradient-to-br from-blue-300 via-blue-200 to-blue-300">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-blue-50 px-4 py-2 rounded-full mb-6">
              <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
              <span className="text-blue-700 text-sm font-medium tracking-wide">Who We Are</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Building Intelligent Systems That
              <span className="text-blue-600"> Think & Evolve</span>
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              We combine cutting-edge AI technology with human-centric design to create solutions that transform businesses.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Mission Content */}
            <div>
              <div className="relative">
                <div className="absolute -left-4 -top-4 w-24 h-24 bg-blue-100 rounded-2xl -z-0"></div>
                <div className="relative bg-white border border-gray-200 rounded-2xl p-8 shadow-lg">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">Our Mission</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Our mission is to provide top-quality software solutions that leverage the power of 
                    artificial intelligence and computer vision to businesses of all sizes.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    We strive to exceed our clients' expectations by delivering innovative and secure 
                    solutions that drive growth and success. Our approach ensures clients can harness 
                    the full potential of AI technologies with confidence.
                  </p>
                </div>
              </div>
            </div>

            {/* Process Flow */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-blue-600 rounded-full"></span>
                Our Process
              </h3>
              <div className="space-y-4">
                {[
                  { step: "01", title: "Discovery", desc: "Understand your needs, industry, and challenges", icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" },
                  { step: "02", title: "Design", desc: "Prototype and plan a custom AI solution", icon: "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" },
                  { step: "03", title: "Development", desc: "Build, test, and refine with feedback", icon: "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" },
                  { step: "04", title: "Deployment & Support", desc: "Scale, monitor, and continuously improve", icon: "M13 10V3L4 14h7v7l9-11h-7z" },
                ].map((item) => (
                  <div key={item.step} className="flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-all duration-300 group cursor-pointer">
                    <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-md group-hover:scale-110 transition-transform">
                      {item.step}
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-gray-900 mb-1">{item.title}</h4>
                      <p className="text-gray-500 text-sm">{item.desc}</p>
                    </div>
                    <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gradient-to-br from-white to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What Makes Us <span className="text-blue-600">Different</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our core values drive everything we do, ensuring excellence in every project.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Expertise Card */}
          <div className="relative bg-white border border-white/10 rounded-2xl p-8 hover:scale-105 hover:border-blue-400/50 hover:shadow-[0_0_30px_rgba(59,130,246,0.25)] transition-all duration-300 ">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                <svg className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Expertise</h3>
              <p className="text-gray-600 leading-relaxed">
                Our team consists of highly experienced software developers and dedicated AI specialists 
                with expertise in cloud computing, machine learning, and computer vision. We deliver 
                innovative, impactful, and reliable solutions that drive your business forward.
              </p>
            </div>

            {/* Communication Card */}
          <div className="relative bg-white border border-white/10 rounded-2xl p-8 hover:scale-105 hover:border-blue-400/50 hover:shadow-[0_0_30px_rgba(59,130,246,0.25)] transition-all duration-300 ">
              <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-600 transition-colors duration-300">
                <svg className="w-7 h-7 text-green-600 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Communication</h3>
              <p className="text-gray-600 leading-relaxed">
                Transparent and consistent communication is the cornerstone of every successful project. 
                We work in close partnership with our clients, ensuring you're fully informed and confident 
                throughout every stage of the development process.
              </p>
            </div>

            {/* Approach Card */}
          <div className="relative bg-white border border-white/10 rounded-2xl p-8 hover:scale-105 hover:border-blue-400/50 hover:shadow-[0_0_30px_rgba(59,130,246,0.25)] transition-all duration-300 ">
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-purple-600 transition-colors duration-300">
                <svg className="w-7 h-7 text-purple-600 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Our Approach</h3>
              <p className="text-gray-600 leading-relaxed">
                User-focused design combined with cutting-edge AI research. We prioritize creating 
                intuitive experiences that seamlessly integrate advanced AI capabilities, making 
                complex technology accessible and valuable for your team.
              </p>
            </div>

            {/* Impact Card */}
          <div className="relative bg-white border border-white/10 rounded-2xl p-8 hover:scale-105 hover:border-blue-400/50 hover:shadow-[0_0_30px_rgba(59,130,246,0.25)] transition-all duration-300 ">
              <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-orange-600 transition-colors duration-300">
                <svg className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Our Impact</h3>
              <p className="text-gray-600 leading-relaxed">
                Empowering smarter decisions through intelligent automation. We help businesses reduce 
                operational costs, improve efficiency, and unlock new opportunities with AI-driven 
                insights and automation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-300 via-blue-200 to-blue-300">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <div className="relative bg-white border border-white rounded-2xl p-8 hover:scale-105 hover:border-blue-400/50 hover:shadow-[0_0_30px_rgba(59,130,246,0.25)] transition-all duration-300 ">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-5">
              Ready to Transform Your Business?
            </h2>
            <p className="text-grey-100 mb-8 text-lg">
              Join hundreds of companies that trust us for their AI solutions
            </p>
            <button className="px-8 py-3 bg-blue-400 text-black font-semibold rounded-lg hover:bg-blue-500 transition-all duration-300 shadow-lg hover:shadow-xl">
              Get Started Today
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AboutUs;          